import { AbpMultiTenancyService } from 'abp-ng2-module';
import { Injectable } from '@angular/core';
import { ApplicationInfoDto, CustomerDto, GetCurrentLoginInformationsOutput, SessionServiceProxy, TenantLoginInfoDto, UserLoginInfoDto } from '@shared/service-proxies/service-proxies';

@Injectable()
export class AppSessionService {
    constructor(private _sessionService: SessionServiceProxy, private _abpMultiTenancyService: AbpMultiTenancyService) {}

    private _user: UserLoginInfoDto;

    get user(): UserLoginInfoDto {
        return this._user;
    }

    private _tenant: TenantLoginInfoDto;

    get tenant(): TenantLoginInfoDto {
        return this._tenant;
    }    

    private _application: ApplicationInfoDto;

    get application(): ApplicationInfoDto {
        return this._application;
    }

    get userId(): number {
        return this.user ? this.user.id : null;
    }

    get tenantId(): number {
        return this.tenant ? this.tenant.id : null;
    }

    private _customer: CustomerDto;

    get customer(): CustomerDto {
        return this._customer;
    }

    get customerId(): number {
        return this.customer ? this.customer.id : null;
    }

    getShownLoginName(): string {
        const userName = this._user.userName;
        if (!this._abpMultiTenancyService.isEnabled) {
            return userName;
        }

        return (this._tenant ? this._tenant.tenancyName : '.') + '\\' + userName;
    }

    init(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this._sessionService
                .getCurrentLoginInformations()
                .toPromise()
                .then(
                    (result: GetCurrentLoginInformationsOutput) => {
                        this._application = result.application;
                        this._user = result.user;
                        this._tenant = result.tenant;
                        this._customer = result.customer;
                        resolve(true);
                    },
                    (err) => {
                        reject(err);
                    }
                );
        });
    }

    changeTenantIfNeeded(tenantId?: number): boolean {
        if (this.isCurrentTenant(tenantId)) {
            return false;
        }

        abp.multiTenancy.setTenantIdCookie(tenantId);
        location.reload();
        return true;
    }

    private isCurrentTenant(tenantId?: number) {
        if (!tenantId && this.tenant) {
            return false;
        } else if (tenantId && (!this.tenant || this.tenant.id !== tenantId)) {
            return false;
        }

        return true;
    }
}
